import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatistiquesComponent } from '../statistiques/statistiques.component';
import { NgxsModule } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';
import { DxDashboardControlModule } from 'devexpress-dashboard-angular';
import { LayoutsModule } from 'src/core/layouts/layouts.module';
import { DxSharedModule } from 'src/shared/dx-shared.module';
import { SharedModule } from 'src/shared/shared.module';



@NgModule({
  declarations: [
    StatistiquesComponent
  ],
  imports: [
    SharedModule,
    DxSharedModule,
    DxDashboardControlModule,
    TranslateModule,
    LayoutsModule,
    NgxsModule.forFeature([])
  ],
  exports: [
    StatistiquesComponent
  ]
})
export class StatistiquesModule { }
